/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    4.5: '1.125rem',
    5.5: '1.375rem',
    6.5: '1.625rem',
    8.5: '2.125rem',
    9.5: '2.375rem',
    10.5: '2.625rem',
    11: '2.75rem',
    11.25: '2.8125rem',
    11.5: '2.875rem',
    13.5: '3.375rem',
    15: '3.75rem',
    16.5: '4.125rem',
    18: '4.5rem',
    19: '4.75rem',

    container: {
        sm: '480px',
        md: '768px',
        lg: '992px',
        xl: '1200px',
        xxl: '1536px'
    }
}
